import { useLocale } from "@Src_main/localeProvider";
import React, { useEffect, useState } from "react";
import deFlag from "@Src_main/assets/images/flags/de.svg";
import itFlag from "@Src_main/assets/images/flags/it.svg";
import esFlag from "@Src_main/assets/images/flags/es.svg";
import frFlag from "@Src_main/assets/images/flags/fr.svg";
import enFlag from "@Src_main/assets/images/flags/en.svg";
import { env } from "build/env";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import classes from "./languageSelector.module.scss";
export var LanguageSelector = () => {
  var {
    language,
    setLanguage,
    availableLanguages
  } = useLocale();
  var {
    isMobile
  } = useWindowSize();
  var [isVisible, setIsVisible] = useState(true);
  var [open, setOpen] = useState(false);
  var buttonImages = {
    de: deFlag,
    it: itFlag,
    es: esFlag,
    fr: frFlag,
    en: enFlag
  };
  var sortedLanguages = [language, ...availableLanguages.filter(l => l !== language).sort((a, b) => a.localeCompare(b))];
  var handleScroll = () => {
    if (window.scrollY >= 100) {
      if (isMobile) {
        setIsVisible(false);
      }
      setOpen(false);
    } else {
      if (isMobile) {
        setIsVisible(true);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  function onClick(e, code) {
    if (open) {
      e.stopPropagation();
      setLanguage(code);
      setOpen(false);
    } else {
      setOpen(true);
    }
  }
  if (!isVisible) {
    return null;
  }
  var selectorClass = isMobile ? "".concat(classes['language-selector-mobile'], " uk-box-shadow-medium uk-position-fixed uk-position-bottom") : "".concat(classes['language-selector-desktop'], " uk-box-shadow-medium");
  return /*#__PURE__*/React.createElement("div", {
    id: "language-selector",
    className: selectorClass,
    style: {
      display: 'flex',
      flexDirection: 'column-reverse'
    }
  }, sortedLanguages.filter(x => open || x === language).map(lang => {
    return /*#__PURE__*/React.createElement("div", {
      key: lang,
      style: {
        pointerEvents: 'none'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "45px",
        height: "45px",
        borderRadius: "50%",
        border: "2px solid #8f8a8aff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: buttonImages[lang],
      draggable: false,
      onClick: e => onClick(e, lang),
      style: {
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        objectFit: "cover",
        display: "block",
        pointerEvents: 'auto',
        cursor: 'pointer'
      }
    })));
  }));
};